import z from "zod"

export const GmailIntegrationGenerateAuthUrlResponseDataSchema = z.object({
  url: z.string(),
})

export const GmailIntegrationGetTokenResponseDataSchema = z.object({
  success: z.boolean(),
})

const GmailIntegration = z.object({
  id: z.bigint().transform(String),
  email: z.string(),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
})

export const GmailIntegrationsResponseDataSchema = z.array(GmailIntegration)
